/* eslint-disable import/no-cycle */
import * as types from '../mutationTypes';
import { ROLE_ROOT } from '../../utils/user-roles';

const decodePayload = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

const state = {
  isLogged: false,
  token: '',
  root: false,
  userRoles: [],
  userId: '',
  expireDate: null,
  refreshDate: null,
  voteAccess: false,
  login: '',
  username: '',
  shouldResetPassword: false,
};

const actions = {
  refreshSession({ commit }, { token }) {
    const tokenPayload = decodePayload(token);
    commit(types.REFRESH_SESSION, {
      token,
      root: tokenPayload.root,
      userRoles: tokenPayload.roles,
      userId: tokenPayload.id,
      refreshDate: tokenPayload.iat * 1000,
      expireDate: tokenPayload.exp * 1000,
      voteAccess: tokenPayload.voteAccess,
      login: tokenPayload.username,
      username: tokenPayload.full_username,
      shouldResetPassword: tokenPayload.resetPassword,
    });
  },
  destroySession({ commit }) {
    commit(types.DESTROY_SESSION);
  },
  takeVoteAccess({ commit }) {
    commit(types.TAKE_VOTE_ACCESS);
  },
  setResetPasswordResetAfterLogin({ commit }, payload) {
    commit(types.SET_PASSWORD_RESET_AFTER_LOGIN, payload);
  },
};

const mutations = {
  [types.REFRESH_SESSION](state, {
    token,
    root,
    userRoles,
    userId,
    refreshDate,
    expireDate,
    voteAccess,
    login,
    username,
    shouldResetPassword,
  }) {
    state.isLogged = true;
    state.root = root;
    state.refreshDate = refreshDate;
    state.token = token;
    state.userRoles = userRoles;
    state.userId = userId;
    state.expireDate = expireDate;
    state.voteAccess = voteAccess;
    state.login = login;
    state.username = username;
    state.shouldResetPassword = shouldResetPassword;
    if (root) {
      state.userRoles.push(ROLE_ROOT);
    }
  },
  [types.DESTROY_SESSION](state) {
    state.isLogged = false;
    state.root = false;
    state.refreshDate = null;
    state.token = null;
    state.userRoles = null;
    state.userId = null;
    state.expireDate = null;
    state.voteAccess = false;
    state.login = null;
    state.username = '';
    state.shouldResetPassword = false;
  },
  [types.SET_PASSWORD_RESET_AFTER_LOGIN](state, payload) {
    state.shouldResetPassword = payload.shouldReset;
  },
  [types.TAKE_VOTE_ACCESS](state) {
    state.voteAccess = false;
  },
};

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
};
